import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AssignmentProgressBubbly } from '../../../components/student/AssignmentProgressBubbly';
import type { AssignmentDashboardStats } from '../hooks/useAssignmentDashboardStats';
import { ROUTES } from '../../../utils/constants';
import { DashboardCardSkeleton, DashboardEmptyState, DashboardInlineError } from './dashboardUi';

type Props = {
  stats: AssignmentDashboardStats;
  loading: boolean;
  error: string | null;
  enabled: boolean;
  onRetry?: () => void;
};

export function HomeworkSummaryCard({ stats, loading, error, enabled, onRetry }: Props) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  if (!enabled) return null;

  if (loading) {
    return <DashboardCardSkeleton className="mb-6 min-h-[12rem]" />;
  }

  if (error && stats.total === 0) {
    return (
      <section className="mb-6" aria-label={t('dashboard.studentHome.homeworkSummaryAria')}>
        <DashboardInlineError message={error} onRetry={onRetry} />
      </section>
    );
  }

  if (stats.total === 0) {
    return (
      <section className="mb-6" aria-label={t('dashboard.studentHome.homeworkSummaryAria')}>
        <DashboardEmptyState>{t('dashboard.studentHome.noHomeworkYet')}</DashboardEmptyState>
      </section>
    );
  }

  return (
    <section className="mb-6" aria-label={t('dashboard.studentHome.homeworkSummaryAria')}>
      <AssignmentProgressBubbly
        className="mt-0"
        stats={stats}
        onViewAll={() => navigate(ROUTES.STUDENT_ASSIGNMENTS)}
      />
    </section>
  );
}
